var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SearchWithFilter',{attrs:{"filters":_vm.filters,"selectedFilterCacheKey":"itemSearchInputFilter"},on:{"search":_vm.search},model:{value:(_vm.filter),callback:function ($$v) {_vm.filter=$$v},expression:"filter"}})
}
var staticRenderFns = []

export { render, staticRenderFns }